import React from 'react'
import { message, Popover } from 'antd'
import {
  util, request, auth as userAuth } from 'meinian-package/src/utils'
import { PLATFORM_VALUE, PLATFORM_CONFIG_ENUM, } from 'meinian-package/src/component/enum'
import Icon from 'meinian-package/src/component/icon'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import gouwu from 'image/gouwu.png'
import getFilename from 'component/imageDetail/getFilename'
import { formatNumber100Add } from 'meinian-package/src/utils/number'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import { Li } from 'meinian-package/src/baseComponent'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import versionNumber from 'meinian-package/src/component/useFunModal/versionNumber'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import classNames from 'classnames'
import styles from './index.module.less'

export const Remove = ({
  loginUserInfo,
  platformId,
  imageGroupEntityId,
  inspirationId,
  onDeleteItem,
  trackModule2,
  children
}) => {
  const auth = loginUserInfo?.inspirationPermissions || []
  const remove = (e) => {
    e.stopPropagation()
    if (!userAuth.isPermissions(auth, ['FS03', 'FCS03', 'FS03_CREATOR', 'FCS03_CREATOR'])) {
      message.error(platformId === PLATFORM_VALUE.UPLOAD ? '仅能移除自己上传的图片哦' : '仅能移除自己采集的款式哦')
      return
    }
    ModalConfirm.show({
      title: '确认删除款式？',
      content: '当款式被删除后，在回收站保留30天，超过30天将无法恢复。',
      onOk: async () => {
        try {
          await request.post('/zhikuan/ins/inspiration/remove-from-inspiration', {
            blogList: [{ blogId: imageGroupEntityId }],
            inspirationId
          })
          message.success('已成功删除')
          onDeleteItem?.()
        } catch (err) {
          console.error('/zhikuan/ins/inspiration/remove-from-inspiration', err)
        }
      },
    })
    if (window.location.pathname.startsWith('/meinian/home/workbench')) {
      util.track('mn-workbench-click', {
        module1: '款式查看',
        module2: trackModule2,
        module3: '删除款式',
      })
    }
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {children ? <span className="mn-remove-image" onClick={remove}>{children}</span> : <Tooltip title="删除">
      <span
        className="icon-button"
        onClick={remove}
      >
        <Icon type="m-shanchu" />
      </span>
    </Tooltip>}
  </>
}

export const HasItemImage = ({ itemData }) => {
  const currentDto = itemData?.[PLATFORM_CONFIG_ENUM.get(itemData.platformId).dto]
  const { hasItem } = { ...itemData, ...currentDto }
  return (hasItem ? <img src={gouwu} className="icon" /> : null)
}
export const AnnotateCount = ({ itemData }) => {
  return <div className={styles['image-info-content']}>
    {(itemData.annotationNum || (itemData.duplicateBlogNum > 1 && teamHasAuth('meinian_duplicate_images'))) ? <div className="image-info-num">
      {itemData.annotationNum ? <div className="image-info-num-item">
        <span>批注</span>
        <span>{itemData.annotationNum || 0}</span>
      </div> : null}
      {itemData.annotationNum && (itemData.duplicateBlogNum > 1 && teamHasAuth('meinian_duplicate_images')) ? <div className="has-line" /> : null}
      {(itemData.duplicateBlogNum > 1 && teamHasAuth('meinian_duplicate_images')) ? <div className="image-info-num-item">
        <span>重复</span>
        <span>{formatNumber100Add(itemData.duplicateBlogNum) || 0}</span>
      </div> : null}
    </div> : null}
  </div>
}

export const DownloadImage = ({
  itemData = {},
  children,
}) => {
  const currentDto = itemData?.[PLATFORM_CONFIG_ENUM.get(itemData.platformId).dto]
  const { isAuthLimit } = useVersionNumber()
  const downloadAll = async (e) => {
    if (!isAuthLimit('meinian_download_blog_limit')) {
      versionNumber({
        title: '款式下载'
      })
      return
    }
    request.downloadFromAsync('/zhikuan/mn/export/download-blog-image', {
      type: 1,
      collectOrSampleId: itemData.collectId,
      fileName: itemData.imageGroupEntityId
    }, '.zip')
    util.track('mn-image-download', {
      module1: '单款下载',
      module2: '全部图片'
    })
    e.stopPropagation()
  }
  const download = async (e) => {
    e.stopPropagation()
    request.downloadFromAsync('/zhikuan/mn/export/download-blog-image', {
      type: 1,
      imageUrl: itemData.mainUrl,
      fileName: getFilename(itemData.platformId, currentDto, itemData.sourceTime)
    })
    util.track('mn-image-download', {
      module1: '单款下载',
      module2: '当前图片'
    })
  }

  return itemData.imageNum > 1 ? <Popover
    placement="rightTop"
    trigger="hover"
    content={<>
      <Li className="mn-dropdown-icon-li pr4" onClick={download}>下载当前图片</Li>
      <Li className="mn-dropdown-icon-li pr4" onClick={downloadAll}>下载全部图片</Li>
    </>}
  >
    {children || <span>下载</span>}
  </Popover> : <span onClick={download}>{children || '下载'}</span>
}

export const MoreBtn = ({ className, ...otherProps }) => {
  return <div className={classNames(styles['mn-ins-more-btn'], 'fill-white-bg', className)} {...otherProps}>
    <Icon type="m-gengduo" className="mn-ins-more-btn-icon" />
  </div>
}
